import { createContext } from 'react';

const RowContext = createContext({
	rows: [],
	rowPai: {},
	handleExpand: () => {},
});

export default RowContext;
